import { AxiosInstance } from '../../service/axios-instance';

export interface MachineMaintenanceTicket {
  _id?: string;
  id: string;
  status?: string;
  stamp?: string;
  stamp_end?: string;
  created_at?: string;
  created_by?: string;
  closed_at?: string;
  closed_by?: string;
  maintenance_type?: string;
  message?: string;
  close_message?: string;
  message_done?: string;
  next_maintenance_at?: string | number;
}

export interface OpenMaintenancePayload {
  id: string;
  maintenance_type: string;
  message: string;
  next_maintenance_at?: string | number;
}

export interface CloseMaintenancePayload {
  ticket_id?: string;
  id?: string;
  maintenance_type?: string;
  message: string;
  next_maintenance_at?: string | number;
}

export async function listMachineMaintenances(db: string, filters: Record<string, any> = {}): Promise<MachineMaintenanceTicket[]> {
  const res = await AxiosInstance.post('/maintenances/get_maintenances', filters, {
    params: { db },
    withCredentials: true,
  });
  return res.data;
}

export async function openMachineMaintenance(db: string, payload: OpenMaintenancePayload) {
  const res = await AxiosInstance.post('/maintenances/open', payload, {
    params: { db },
    withCredentials: true,
  });
  return res.data;
}

export async function closeMachineMaintenance(db: string, payload: CloseMaintenancePayload) {
  const res = await AxiosInstance.patch('/maintenances/close', payload, {
    params: { db },
    withCredentials: true,
  });
  return res.data;
}

export async function listEquipaments(db: string): Promise<{ id: string }[]> {
  const res = await AxiosInstance.post('/equipaments/get_equipaments', {}, {
    params: { db },
    withCredentials: true,
  });
  return res.data;
}
